<template>
  <v-content>
    <v-app-bar
      app
      clipped-left
      :style="{ color: getSecondaryColor, 'background-color': getThemeColor }"
      dark
    >
      <v-app-bar-nav-icon
        @click="drawer = !drawer"
        :style="{ color: getSecondaryColor, 'background-color': getThemeColor }"
      />
      <div class="title ml-3 mt-4" style="display: block">
        <span v-if="$vuetify.breakpoint.mdAndUp">{{ getAppName }}</span>
        <span v-if="$vuetify.breakpoint.smAndDown">{{
          getAppName.split(" ")[0]
        }}</span>
        |
        <span class="hidden-sm-and-down">
          <small>{{ getUserCompany.emis }}</small>
          <br />
        </span>
        <SwitchCompany :userId="getCurrentUser.id"></SwitchCompany>
      </div>

      <v-spacer />
      <span class="h3 hidden-sm-and-down">
        <v-icon>mdi-google-maps</v-icon>
        {{ title }}
      </span>
      <v-spacer />
      <!-- <SwitchStudent :userId="getCurrentUser.id" class="mt-12"></SwitchStudent> -->
      <span class="font-weight-light"></span>
      <!-- <DonateButton></DonateButton> -->
      <v-btn
        class="ml-14"
        fab
        x-small
        color="warning"
        @click="goToSwitchboard()"
      >
        <v-icon>mdi-apps</v-icon>
      </v-btn>
      <v-btn class="ml-4" fab x-small color="red" @click="goBack()">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      app
      clipped
      :style="{ color: getSecondaryColor, 'background-color': getThemeColor }"
    >
      <v-list dense dark>
        <template v-for="(item, i) in items">
          <v-row
            v-if="item.heading"
            :key="i + Math.random() + Math.random()"
            align="center"
          >
            <v-col cols="6">
              <v-subheader
                v-if="item.heading"
                :style="{
                  color: getSecondaryColor,
                  'background-color': getThemeColor,
                }"
                >{{ item.heading }}</v-subheader
              >
            </v-col>
            <v-col cols="6" class="text-right">
              <v-btn
                small
                text
                :style="{
                  color: getSecondaryColor,
                  'background-color': getThemeColor,
                }"
                >edit</v-btn
              >
            </v-col>
          </v-row>
          <v-divider
            v-else-if="item.divider"
            :key="i + Math.random() + Math.random()"
            dark
            class="my-4"
          />

          <v-list-item
            v-else-if="getCurrentUser.alevel >= item.alevel"
            :key="i + Math.random() + Math.random()"
            link
          >
            <v-list-item-action>
              <v-icon
                :style="{
                  color: getSecondaryColor,
                  'background-color': getThemeColor,
                }"
                @click="routeTo({ name: item.route })"
                >{{ item.icon }}</v-icon
              >
            </v-list-item-action>
            <v-list-item-content
              :style="{
                color: getSecondaryColor,
                'background-color': getThemeColor,
              }"
            >
              <v-list-item-title @click="routeTo({ name: item.route })">{{
                item.text
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-list-item>
          <v-list-item-action>
            <v-icon
              @click="signOut"
              :style="{
                color: getSecondaryColor,
                'background-color': getThemeColor,
              }"
              >exit_to_app</v-icon
            >
          </v-list-item-action>
          <v-list-item-content
            :style="{
              color: getSecondaryColor,
              'background-color': getThemeColor,
            }"
          >
            <v-list-item-title @click="signOut">Sign Out</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <slot />
    <Loader />
  </v-content>
</template>

<script>
import Loader from "@/components/Loader";
import axios from "@/plugins/axios";
import SwitchCompany from "@/components/myLibrary/SwitchCompany.vue";

import { mapGetters } from "vuex";
// import DonateButton from "@/components/PayPal/DonateButton.vue";

export default {
  components: {
    //DonateButton,
    Loader,
    SwitchCompany,
  },
  computed: mapGetters([
    "getAccessToken",
    "getCurrentUser",
    "getThemeColor",
    "getSecondaryColor",
    "getAppName",
    "getUserCompany",
    "getThemeStyle",
  ]),

  props: {
    source: String,
    title: String,
  },
  mounted() {
    this.$store.commit("setScreenWidth", this.$vuetify.breakpoint.width);
  },
  updated() {
    this.$store.commit("setScreenWidth", this.$vuetify.breakpoint.width);
  },
  data: () => ({
    drawer: false,

    items: [
      { icon: "apps", text: "Switchboard", route: "switchboard", alevel: 1 },
      {
        icon: "touch_app",
        text: "Front Page",
        route: "company-website",
        alevel: 1,
      },
      // {
      //   icon: "mdi-image",
      //   text: "Gallery",
      //   route: "images-gallery",
      //   alevel: 1,
      // },
      // {
      //   icon: "mdi-office",
      //   text: "Learning Materials",
      //   route: "learning-materials",
      //   alevel: 1
      // },
      // {
      //   icon: "mdi-card-account-details",
      //   text: "Manage ID Cards",
      //   route: "manage-students-ids",
      //   alevel: 7
      // },
      { divider: true },
      { heading: "Quotations" },
      {
        icon: "mdi-receipt",
        text: "Quotations",
        route: "invoices-and-quotes",
        alevel: 7,
      },

      { divider: true },

      { heading: "Database" },
      {
        icon: "mdi-database",
        text: "Manage Database",
        route: "data-crud",
        alevel: 7,
      },
      // {
      //   icon: "mdi-cart-arrow-right",
      //   text: "Manage Products",
      //   route: "manage-products",
      //   alevel: 7,
      // },
      { heading: "Settings" },
      {
        icon: "mdi-cog",
        text: "Manage Settings",
        route: "settings",
        alevel: 7,
      },
      // { icon: "add", text: "Manage Lessons", route: "crud-lesson", alevel: 15 },
      // {
      //   icon: "mdi-database-plus",
      //   text: "Admin Database",
      //   route: "crud-admin",
      //   alevel: 7
      // },
      // {
      //   icon: "mdi-database-plus",
      //   text: "School Admin",
      //   route: "school-admin-dashboard",
      //   alevel: 9
      // },
      // {
      //   icon: "mdi-cash-multiple",
      //   text: "School Finances",
      //   route: "finance-switchboard",
      //   alevel: 9
      // },

      { divider: true },
    ],
  }),
  methods: {
    routeTo(routeObj) {
      this.$router.push(routeObj);
    },
    goBack() {
      this.$router.back();
    },
    goToSwitchboard() {
      this.$router.push({ name: "switchboard" });
    },
    signOut() {
      axios
        .postDataWithToken("/auth/logout", {}, this.getAccessToken)
        .then((response) => {
          if (response.loggedOut) {
            this.$store.commit("setAuthenticated", false);
            this.$store.commit("setCurrentUser", {});
            // this.$store.commit("setCurrentStudent", {});
            localStorage.clear();
            this.$router.push({ path: "/", params: { signOut: true } });
          }
        });
    },
  },
};
</script>

<style scoped>
#keep .v-navigation-drawer__border {
  display: none;
}
</style>
